if (!window.Maximize) window.Maximize = {};
if (!window.Maximize.loadedScript) window.Maximize.loadedScript = [];

if (!window.Maximize.loadedScript.includes('collection-menu-filters.js')) {
  window.Maximize.loadedScript.push('collection-menu-filters.js');

  const FILTER_PARAM = 'filter_collection';

  const collectionPath = (handle) => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root}collections/${encodeURIComponent(handle)}`;
  };

  const collectionHandleFromUrl = (url) => {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      const match = parsed.pathname.match(/\/collections\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  };

  window.Maximize.getCollectionFilterFetchUrl = function (sectionId, additionalSearchParams, searchParams) {
    const handle = window.Maximize.collectionFilterHandle || window.Maximize.collectionFilterParentHandle;
    const requestUrl = new URL(collectionPath(handle || ''), window.location.origin);
    const params = new URLSearchParams(searchParams || '');
    params.delete(FILTER_PARAM);
    params.delete('view');
    params.delete('section_id');
    params.delete('sections');
    if (additionalSearchParams) {
      new URLSearchParams(additionalSearchParams).forEach((value, key) => {
        requestUrl.searchParams.set(key, value);
      });
    }
    params.forEach((value, key) => {
      requestUrl.searchParams.set(key, value);
    });
    requestUrl.searchParams.set('section_id', sectionId);
    return `${requestUrl.pathname}${requestUrl.search}`;
  };

  window.Maximize.buildCollectionFilterPublicParams = function (searchParams) {
    const params = new URLSearchParams(searchParams || '');
    params.delete('view');
    params.delete('section_id');
    params.delete('sections');
    const handle = window.Maximize.collectionFilterHandle;
    const parent = window.Maximize.collectionFilterParentHandle;
    if (handle && parent && handle !== parent) {
      params.set(FILTER_PARAM, handle);
    } else {
      params.delete(FILTER_PARAM);
    }
    return params.toString();
  };

  const htmlToDocument = (html) => new DOMParser().parseFromString(html || '', 'text/html');

  const fetchCollectionDocument = async (handle, searchParams) => {
    const path = collectionPath(handle);
    const extra = searchParams ? `&${searchParams}` : '';
    const view = window.Maximize.collectionFilterView || 'above-filter';
    const viewQuery = `view=${encodeURIComponent(view)}`;
    const candidates = [
      { url: `${path}?${viewQuery}&section_id=product-grid${extra}`, json: false },
      { url: `${path}?${viewQuery}&sections=product-grid${extra}`, json: true },
      { url: `${path}?sections=product-grid${extra}`, json: true },
      { url: `${path}?section_id=product-grid${extra}`, json: false },
      { url: `${path}${searchParams ? `?${searchParams}` : ''}`, json: false },
    ];

    for (const candidate of candidates) {
      try {
        const response = await fetch(candidate.url, { credentials: 'same-origin' });
        if (!response.ok) continue;
        const contentType = response.headers.get('content-type') || '';
        let doc;
        if (candidate.json || contentType.includes('application/json')) {
          const payload = await response.json();
          const html = payload['product-grid'] || payload[Object.keys(payload)[0]] || '';
          if (!html) continue;
          doc = htmlToDocument(html);
        } else {
          doc = htmlToDocument(await response.text());
        }
        if (doc.getElementById('ProductGridContainer') || doc.getElementById('ItemsGrid')) {
          return doc;
        }
      } catch (error) {
        console.error('Collection filter fetch failed:', candidate.url, error);
      }
    }
    return null;
  };

  const findById = (root, id) => {
    if (!root) return null;
    if (root.getElementById) {
      const match = root.getElementById(id);
      if (match) return match;
    }
    if (root.querySelectorAll) {
      const templates = root.querySelectorAll('template');
      for (const template of templates) {
        const match = findById(template.content, id);
        if (match) return match;
      }
    }
    return null;
  };

  const setToolbarProductCount = (countHtml) => {
    if (!countHtml) return;
    ['ProductCount_header', 'ProductCountDrawer', 'FacetsProductCount'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = countHtml;
    });
  };

  const replaceHtmlById = (doc, id) => {
    const current = document.getElementById(id);
    const next = findById(doc, id);
    if (current && next) {
      current.innerHTML = next.innerHTML;
      return true;
    }
    return false;
  };

  const captureGridClass = () => {
    const grid = document.getElementById('ItemsGrid');
    return grid ? grid.className : '';
  };

  const restoreGridClass = (className) => {
    const grid = document.getElementById('ItemsGrid');
    if (grid && className) grid.className = className;
  };

  const renderCollectionDocument = (doc, gridClass) => {
    const layoutClass = gridClass || captureGridClass();
    let updated = replaceHtmlById(doc, 'ProductGridContainer');
    if (!updated) updated = replaceHtmlById(doc, 'ItemsGrid');

    restoreGridClass(layoutClass);

    const fetchedCount =
      findById(doc, 'FacetsProductCount') ||
      findById(doc, 'ProductCount_header') ||
      findById(doc, 'ProductCountDrawer');
    if (fetchedCount) setToolbarProductCount(fetchedCount.innerHTML);

    document.querySelectorAll('#ProductGridContainer [x-cloak], #ProductGridContainer .loading-cover').forEach((el) => {
      el.removeAttribute('x-cloak');
      if (el.classList.contains('loading-cover')) el.style.display = 'none';
    });

    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid && window.Alpine && typeof Alpine.initTree === 'function') {
      Alpine.initTree(productGrid);
    }
    restoreGridClass(layoutClass);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
    return updated;
  };

  const initCollectionMenuFilters = () => {
    const nav = document.querySelector('[data-collection-menu-filters]');
    if (!nav || nav.dataset.filtersReady === 'true') return;
    nav.dataset.filtersReady = 'true';

    const parentHandle = nav.dataset.parentHandle;
    const parentUrl = nav.dataset.parentUrl || collectionPath(parentHandle);

    window.Maximize.collectionFilterParentHandle = parentHandle;
    window.Maximize.collectionFilterHandle = parentHandle;
    window.Maximize.collectionFilterPath = parentUrl;
    window.Maximize.collectionFilterView = nav.dataset.templateView || '';
    const parentGridClass = captureGridClass();

    const buttons = () => Array.from(nav.querySelectorAll('[data-collection-handle], [data-collection-url]'));

    const buttonHandle = (button) =>
      button.dataset.collectionHandle || collectionHandleFromUrl(button.dataset.collectionUrl);

    const setActive = (handle) => {
      buttons().forEach((button) => {
        const isActive = buttonHandle(button) === handle;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const applyCollection = async (handle, { pushUrl = true, searchParams = '' } = {}) => {
      if (!handle) return;
      window.Maximize.collectionFilterHandle = handle;
      window.Maximize.collectionFilterPath = collectionPath(handle);
      setActive(handle);
      const activeButton = buttons().find((button) => buttonHandle(button) === handle);
      if (activeButton && activeButton.dataset.productCountLabel) {
        setToolbarProductCount(activeButton.dataset.productCountLabel);
      }
      document.dispatchEvent(new CustomEvent('collection-menu-filter:changed', { detail: { handle } }));

      if (pushUrl && typeof history.pushState === 'function') {
        const qs = window.Maximize.buildCollectionFilterPublicParams(searchParams);
        history.pushState({ searchParams: qs }, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`);
      }

      try {
        const doc = await fetchCollectionDocument(handle, searchParams);
        if (!doc || !renderCollectionDocument(doc, parentGridClass)) {
          throw new Error('Collection products were not returned');
        }
      } catch (error) {
        console.error('Failed to apply collection filter:', error);
      } finally {
        setActive(window.Maximize.collectionFilterHandle);
      }
    };

    nav.addEventListener('click', (event) => {
      const button = event.target.closest('[data-collection-handle], [data-collection-url]');
      if (!button || !nav.contains(button) || button.disabled) return;
      event.preventDefault();
      const handle = buttonHandle(button);
      if (!handle || handle === window.Maximize.collectionFilterHandle) return;
      applyCollection(handle);
    });

    window.addEventListener('popstate', () => {
      const handle = new URLSearchParams(window.location.search).get(FILTER_PARAM) || parentHandle;
      applyCollection(handle, { pushUrl: false, searchParams: window.location.search.slice(1) });
    });

    const initialHandle = new URLSearchParams(window.location.search).get(FILTER_PARAM);
    if (initialHandle && initialHandle !== parentHandle) {
      applyCollection(initialHandle, { pushUrl: false, searchParams: window.location.search.slice(1) });
    } else {
      setActive(parentHandle);
    }
  };

  const start = () => {
    if (document.querySelector('[data-collection-menu-filters]')) {
      initCollectionMenuFilters();
      return;
    }
    document.addEventListener(
      'DOMContentLoaded',
      () => initCollectionMenuFilters(),
      { once: true }
    );
  };

  start();
}
